
<template>
    <div>
        <div class="information_input margin-top1">
            <div class="information_Title">关键字</div>
            <div class="input_el" style="width:85%">
                <div style="padding: 0px 0 10px 0;">
                    <span>A段： &nbsp;</span>
                    <el-input
                        class="width97"
                        type="textarea"
                        autosize
                        placeholder="请输入关键字"
                        v-model="Keyword1"
                        maxlength="250"
                        show-word-limit
                    ></el-input>
                </div>
                <div style="padding: 0px 0 10px 0;">
                    <span>B段： &nbsp;</span>
                    <el-input
                        class="width97"
                        type="textarea"
                        autosize
                        placeholder="请输入关键字"
                        v-model="Keyword2"
                        maxlength="250"
                        show-word-limit
                    ></el-input>
                </div>
                <div style="padding: 0px 0 10px 0;">
                    <span>C段： &nbsp;</span>
                    <el-input
                        class="width97"
                        type="textarea"
                        autosize
                        placeholder="请输入关键字"
                        v-model="Keyword3"
                        maxlength="250"
                        show-word-limit
                    ></el-input>
                </div>
                <div style="padding: 0px 0 10px 0;">
                    <span>D段： &nbsp;</span>
                    <el-input
                        class="width97"
                        type="textarea"
                        autosize
                        placeholder="请输入关键字"
                        v-model="Keyword4"
                        maxlength="250"
                        show-word-limit
                    ></el-input>
                </div>
            </div>
            <div style="float: right;">
                <el-button type="primary" @click="Keyword">生成关键字</el-button>
            </div>
        </div>
        <div class="information_tips">关键字注意 ：(多个值用双逗号隔开比如:[a,,b,,c])</div>
        <div class="titlelist" v-show="generatekeyword">
            <div class="Minister-top-top informationbackground">
                <div
                    class="Minister-top-right Minister-top-color"
                    @click="keywordClick"
                >{{variantkeyword}}</div>
            </div>
            <el-table
                v-show="keywordtypt"
                ref="keywordTable"
                :data="KeywordData"
                tooltip-effect="dark"
                style="width: 100%;padding: 0 0 0 10px;"
                @selection-change="keywordChange">
                <el-table-column type="selection" width="20"></el-table-column>
                <el-table-column label="全部" width="50"></el-table-column>
                <el-table-column label="生成的关键字">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.name" @change="dataChange" style="width:80%"></el-input>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="关键字的相似度" width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.val}}%</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: "Keyword",
    data() {
        return {
            // 关键字
            variantkeyword: "收起",
            keywordtypt: true,
            generatekeyword: false,
            Keyword1: "", //关键字1
            Keyword2: "", //关键字2
            Keyword3: "", //关键字3
            Keyword4: "", //关键字4
            KeywordData: [] //关键字
        };
    },
    mounted() {},
    created() {},
    methods: {
        // 关键字展开
        keywordClick() {
            this.keywordtypt = !this.keywordtypt;
            if (this.variantkeyword === "展开") {
                this.variantkeyword = "收起";
            } else {
                this.variantkeyword = "展开";
            }
        },
        // 生成关键字
        Keyword() {
            const chineseEnglish1 = this.Keyword1.replace(/，，/gi, ",,");
            const chineseEnglish2 = this.Keyword2.replace(/，，/gi, ",,");
            const chineseEnglish3 = this.Keyword3.replace(/，，/gi, ",,");
            const chineseEnglish4 = this.Keyword4.replace(/，，/gi, ",,");
            let Keyword1 = chineseEnglish1.split(",,");
            let Keyword2 = chineseEnglish2.split(",,");
            let Keyword3 = chineseEnglish3.split(",,");
            let Keyword4 = chineseEnglish4.split(",,");
            if (
                this.Keyword1 == "" ||
                this.Keyword2 == "" ||
                this.Keyword3 == "" ||
                this.Keyword4 == ""
            ) {
                this.$message.error("标题不能为空");
            } else {
                Keyword1.forEach(element => {
                    Keyword2.forEach(item => {
                        Keyword3.forEach(val => {
                            Keyword4.forEach(ele => {
                                var params = {
                                    name: `${element} ${item} ${val} ${ele}`,
                                    val: 0
                                };
                                this.KeywordData.push(params);
                            });
                        });
                    });
                });
            }
            this.keywordSimilarity();
        },
        keywordSimilarity() {
            let str = "";
            this.KeywordData.forEach((item, index) => {
                if (index == 0) {
                    item.val = 100;
                    str = this.KeywordData[0].name;
                } else {
                    const arr = item.name.split(" ");
                    arr.forEach(ele => {
                        if (str.includes(ele)) {
                            item.val += 25;
                        }
                    });
                }
            });
            this.setSort();
            this.generatekeyword = true;
        },
        setSort() {
            const arr = this.KeywordData;
            var min;
            var arrname;
            for (let i = 1; i < arr.length; i++) {
                for (var j = i; j < arr.length; j++) {
                    if (arr[i].val > arr[j].val) {
                        min = arr[j].val;
                        arr[j].val = arr[i].val;
                        arr[i].val = min;

                        arrname = arr[j].name;
                        arr[j].name = arr[i].name;
                        arr[i].name = arrname;
                    }
                }
            }
            this.keywordElection();
        },
        keywordElection() {
            console.log(this.KeywordData)
            this.KeywordData.forEach(row => {
                this.$refs.keywordTable.toggleRowSelection(row);
            });
        },
        keywordChange(val) {
            console.log(val);
        },
        dataChange() {}
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .width97 .el-textarea__inner:focus{
        outline: 0;
        border-color: #cce198;
    }
}
</style>